// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.jpg";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
// Porject Images
//import projectImage1 from "./assets/projects/project1.jpg";
//import projectImage2 from "./assets/projects/project2.jpg";
//import projectImage3 from "./assets/projects/project3.jpg";
//import projectImage4 from "./assets/projects/project4.jpg";
//import projectImage5 from "./assets/projects/project5.jpg";
//import projectImage6 from "./assets/projects/project6.jpg";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "AL Hazir Akbar",
  tagline: "Pledging top-notch quality tests for an impeccable user experience.",
  img: profile,
  about: `I am a graduate of Computer Science with a specialization in IT. I have experience in IT product development. I completed a 6-week
  Quality Assurance bootcamp at Binar Academy, where I learned the basics of Quality Assurance, testing types, Agile and Scrum
  methodologies, as well as API testing using Postman. I also have experience in creating test cases and scenarios, reporting bugs, and
  conducting manual testing and deployment case studies. My CV showcases my skills in QA and API testing.`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/alhazirakbar/",
  github: "https://github.com/alhazirakbar00",
  twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Technical Support",
    Company: `DAAK Amikom`,
    Location: "Yogyakarta",
    Type: "Internship",
    Duration: "Sep 2021 - Jan 2023",
  },
  {
    Position: "Technical Support Specialist",
    Company: `Telkom Akses`,
    Location: "Banda Aceh",
    Type: "Internship",
    Duration: "Mar 2017 - Jun 2017",
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Bachelor Degree in Of Engineering,",
    Company: "Universitas AMIKOM Yogyakarta",
    Location: "Yogyakarta",
    Type: "Cmlaude",
    Duration: "Jul 2018 - Oct 2023",
  },
  {
    Position: "Quality Assurance",
    Company: `Binar Academy`,
    Location: "Online",
    Type: "Bootcamp",
    Duration: "6 Week : Mar - Apr 2023",
  },
];


// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
};

// Enter your Project Details here
export const projectDetails = [

//   {
//     title: "Project title 1",
//     image: projectImage1,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
//   {
//     title: "Project title 2",
//     image: projectImage2,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
//   {
//     title: "Project title 3",
//     image: projectImage3,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
//   {
//     title: "Project title 4",
//     image: projectImage4,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
//   {
//     title: "Project title 5",
//     image: projectImage5,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
//   {
//     title: "Project title 6",
//     image: projectImage6,
//     description: `This is sample project description random things are here in description This is sample
// project lorem ipsum generator for dummy content`,
//     techstack: "HTML/CSS, JavaScript",
//     previewLink: "https://google.com",
//     githubLink: "https://github.com",
//   },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "alhazir.akbar@gmail.com",
  phone: "Let's connect!",
};
